import React, { useContext, useEffect, useState } from 'react'
import AgoraSignallingComponent from 'src/components/AgoraSingallingComponent/AgoraSignallingComponent'
import { DISPATCH_EVENT_KEYS } from 'src/consumer/constants'
import { ProfileContext } from 'src/consumer/context/ProfileContext'

export default function AgoraSignallingComponentForSupportPortalUsers() {
  const { profileData } = useContext(ProfileContext)
  const [userId, setUserId] = useState(profileData?.userId)

  useEffect(() => {
    if (profileData?.userId) {
      setUserId(profileData.userId)
    }
  }, [profileData])

  if (!userId) return null

  return (
    <AgoraSignallingComponent
      deviceId={userId}
      dispatchEventKey={DISPATCH_EVENT_KEYS.supportSignalingEvent}
    />
  )
}
